module.exports = __webpack_public_path__ + "static/media/td.fd7a8d69.png";